import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye, ShoppingCart } from "lucide-react";
import { formatPrice } from "../utils/helper";
import { useCart } from "react-use-cart";
import AddToCartModal from "./AddCartToModal";

export default function ProductCard({ product, viewMode = "grid" }) {
  const { addItem } = useCart();
  const [showModal, setShowModal] = useState(false);

  const handleAddToCart = (quantity, item = product) => {
  if (product.variants.length === 1) {
    const variant = product.variants[0];
    addItem({
  id: variant.id,             
  variantId: variant.id,      
  name: product.name,
  price: product.price,
  image: product.image,
  quantity,
  variants: product.variants || [],
});

  } else {
    addItem(item, quantity);
  }
  setShowModal(false);
};

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  if (viewMode === "list") {
    return (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-[#f5eee6]">
        <div className="flex">
          <div className="w-48 h-48 relative overflow-hidden">
            <img
              src={`${process.env.REACT_APP_API_URL}/storage/${product.image}`}
              alt={product.name}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </div>
          <div className="flex-1 p-6 flex flex-col justify-between text-[#7a6e5f]">
            <div>
              <h3 className="text-xl font-serif font-semibold mb-2">
                {product.name}
              </h3>
              <p className="text-[#809080] font-medium mb-4">
                {formatPrice(product.price)}
              </p>
              <p className="text-sm opacity-80">{product.description}</p>
            </div>
            <div className="flex gap-3 flex-wrap mt-4">
              <Link
                to={`/products/${product.id}`}
                className="inline-flex items-center gap-2 bg-[#809080] text-white px-5 py-2 rounded-md hover:bg-[#6d7d6d] transition-colors"
              >
                <Eye className="w-4 h-4" />
                View Details
              </Link>
              <button
                onClick={openModal}
                className="inline-flex items-center gap-2 bg-[#7a6e5f] text-white px-5 py-2 rounded-md hover:bg-[#6b6154] transition-colors"
              >
                <ShoppingCart className="w-4 h-4" />
                Add to Cart
              </button>
            </div>
          </div>
        </div>

        {showModal && (
          <AddToCartModal
            product={product}
            onClose={closeModal}
            onConfirm={handleAddToCart}
          />
        )}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden group border border-[#f5eee6]">
      {showModal && (
        <AddToCartModal
          product={product}
          onClose={closeModal}
          onConfirm={handleAddToCart}
        />
      )}
      <div className="relative overflow-hidden">
        <img
          src={`${process.env.REACT_APP_API_URL}/storage/${product.image}`}
          alt={product.name}
          className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-[#7a6e5f] bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
          <Link
            to={`/products/${product.id}`}
            className="bg-white text-[#7a6e5f] font-medium px-5 py-2 rounded-md opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-300 flex items-center gap-2"
          >
            <Eye className="w-4 h-4" />
            View Details
          </Link>
        </div>
      </div>

      <div className="p-5 text-[#7a6e5f]">
        <h3 className="text-lg font-serif font-semibold">{product.name}</h3>
        <p className="text-[#809080] mt-1 font-medium">
          {formatPrice(product.price)}
        </p>
        <p className="text-sm opacity-80 mt-2 mb-4">{product.description}</p>
        <button
          onClick={openModal}
          className="w-full bg-[#809080] hover:bg-[#6d7d6d] text-white py-2 rounded-md transition"
        >
          Add This to Cart
        </button>
      </div>
    </div>
  );
}
